
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useEffect, useState } from "react";
import Mapa from "../../../components/Mapa";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schemaFormularioNotificar } from "../../../schema/validacion-notificar";
import { getMotivos, reportarNoNotificada } from "../../../services";
import { MuniSpinner2 } from "../../../components";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import { formFile } from "../../../utils/formFile";
import { reportarActa } from "../../../handlers/notificadores.handler";
import { useFilterActasNotificador } from "../../../hooks/useFilterActasNotificador";
import PersonIcon from '@mui/icons-material/Person';
import BadgeNumero from "../../../components/BadgeNumero";
import ReportIcon from '@mui/icons-material/Report';


const ModalMotivo = ({ titleModal, row, setRefetch }) => {
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { motivos, actas } = useNotificadoresStore()
    const [location, setLocation] = useState(null);
    const { actasRelacionadas } = useNotificadoresStore();

    // console.log(actasRelacionadas)


    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        trigger,
    } = useForm({
        resolver: yupResolver(schemaFormularioNotificar),
        defaultValues: { id: row.id },
    });

    const [base64, setBase64] = useState(null);

    // Observa el campo del archivo
    const file = watch('archivo');

    // Convierte el archivo a base64 cuando se selecciona
    const handleFileChange = () => {
        if (file && file.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64(reader.result); // Convertir archivo a base64
            };
            reader.readAsDataURL(file[0]); // Lee el archivo seleccionado
        }
    };

    // Llama a handleFileChange cuando el archivo cambia
    useEffect(() => {
        handleFileChange();
    }, [file]);

    // const filterActas = useFilterActasNotificador();



    function handleLocationClick() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error, { enableHighAccuracy: true });
        } else {
            console.log("Geolocation not supported");
        }
    };

    function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        setValue('ubicacion', [latitude, longitude])
        setLocation({ latitude, longitude });
        trigger('ubicacion');
    };

    function error() {
        console.log("Unable to retrieve your location");
    };

    const onSubmit = async (data) => {

        // const payload = {
        //     ...data,
        //     acta_id: data.id,
        //     latitud: data.ubicacion[0],
        //     longitud: data.ubicacion[1],
        //     file: base64 // archivo en base64
        // };
        // console.log(payload)

        // reportarActa(payload);
        data.accion = "no-notificar"
        data.array_ids = actasRelacionadas?.map(afm => afm.id)
        data.file = data.archivo
        data.latitud = data.ubicacion[0]
        data.longitud = data.ubicacion[1]
        data.acta_id = data.id
        // reportarActa(data, filterActas);
        reportarActa(data, setRefetch);

        // reportarActa( await formFile(data),filterActas);

        // const payload = { ...data }
        // if (data.archivo && data.archivo[0]) {
        //     const archivo = data.archivo[0];
        //     payload.archivo = await toBase64(archivo);
        // }
        // payload.acta_id = row.id;
        // const result = await reportarNoNotificada(payload);
        // if (result) quitarActa(row.id);
    }

    // const toBase64 = (file) => new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = (error) => reject(error);
    // })

    // const getMotivosForm = async () => {
    //     const result = await getMotivos();
    //     if (result) setMotivos(result);
    // }

    // useEffect(() => {
    //     if (!motivos) getMotivosForm();
    // }, [])

    return (
        <>
            <Modal
                show={modals.includes('modal_motivo')}
                onHide={() => handlerModal({ modal: false, modalName: "modal_motivo" })}
                size="lg"
                aria-labelledby="contained-modal-title-center"
                centered
                style={{
                    backgroundColor: modals.length > 1 ? 'rgba(0,0,0,0.4)' : '',
                }}
            >
                <div className="position-relative">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form className="col-12 row position-relative" onSubmit={handleSubmit(onSubmit)}>
                            {
                                loads.includes("load_notificar") &&
                                <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: "999999" }}>
                                    <MuniSpinner2 />
                                </div>
                            }
                            <div className="col-12 col-md-5">
                                <Form.Group className="col-12">
                                    <Form.Label className="m-0">Motivo*</Form.Label>
                                    <Form.Select isInvalid={!!errors.motivo_id} {...register("motivo_id")}
                                    >
                                        <option value="">Seleccione un motivo</option>
                                        {motivos?.map((motivo) => (
                                            <option key={motivo.id} value={motivo.id}>
                                                {motivo.nombre}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <div className="text-danger" style={{ height: "25px" }}>{errors.motivo_id?.message}</div>
                                    {
                                        watch('motivo_id') == 10 &&
                                        <>
                                            <Form.Label className="m-0">Detalle*</Form.Label>
                                            <Form.Control
                                                disabled={watch('motivo_id') != '10'}
                                                isInvalid={!!errors.motivoManual} {...register("motivoManual")} type="text" placeholder="Escriba el motivo" />
                                            <div className="text-danger" style={{ height: "25px" }}>{errors.motivoManual?.message}</div>
                                        </>
                                    }

                                </Form.Group>

                                <Form.Group className="col-12">
                                    <Form.Label className="m-0">Foto*</Form.Label>
                                    <Form.Control isInvalid={!!errors.archivo} {...register("archivo")}
                                        type="file" id="photo" capture="environment" accept="image/*,video/*" />
                                    <div className="text-danger" style={{ height: "25px" }}>{errors.archivo?.message}</div>
                                </Form.Group>

                                <Form.Group className="col-12">
                                    <Form.Label className="m-0" >Observación</Form.Label>
                                    <Form.Control  {...register("observacion")} as={"textarea"} style={{ resize: "none" }} />
                                    <div className="text-danger" style={{ height: "25px" }}>{errors.observacion?.message}</div>
                                </Form.Group>
                            </div>

                            <Form.Group className="col-12 col-md-7">
                                <Form.Label className="m-0" >Ubicación*</Form.Label>
                                <Button onClick={() => handleLocationClick()} size="sm" style={{ width: "100%" }}>Cargar ubicacion</Button>
                                <div className="col-12  mt-2">
                                    <div style={{ height: "205px", width: "100%" }} className={`border border-2 ${errors.ubicacion ? "border-danger" : "border-secondary-subtle"} `}>
                                        <Mapa latitud={location?.latitude} longitud={location?.longitude} />
                                    </div>
                                </div>
                                <div className="text-danger" style={{ height: "25px" }}>{errors?.ubicacion?.message}</div>
                            </Form.Group>




                            <hr className="my-4" />
                            {
                                actasRelacionadas?.length > 1 &&
                                <div className="d-flex flex-column gap-2 align-items-center mb-4 justify-content-center">
                                    <div className="d-flex justify-content-center gap-2 align-items-center">
                                        <PersonIcon />
                                        <p className="m-0">Actas relacionadas al mismo titular</p>
                                    </div>
                                    <div className="d-flex  gap-2 ">
                                        {
                                            actasRelacionadas?.map(acta => {
                                                return (
                                                    <div key={acta?.id}>
                                                        <BadgeNumero numero={acta?.numero_infraccion} estado_id={acta?.estado_id} size={'sm'} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }

                            {/* <TextInput name="observacion" label="Observación" disabled={row?.observacion} /> */}
                            <div className="d-flex w-100 justify-content-center">
                                <Button /* disabled={isLoadingModal} */ type="submit" className="btn-sm mx-3 btn-warning" style={{ width: "fit-content" }}>
                                    <ReportIcon /> Reportar {actasRelacionadas?.length > 1 ? 'actas' : 'acta'}
                                </Button>
                            </div>

                        </Form>



                    </Modal.Body>
                </div>
            </Modal>


        </>
    );
}
export default ModalMotivo;